// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607080632/js/" + chunkId + "." + {"44":"8cb01e00","225":"b8bb3b37","481":"93b06944","486":"0cffbef5","770":"c8a2ef93"}[chunkId] + ".0.4189420334364371.chunk.js";
};